// ─── Qué pestaña muestra la pantalla de campañas ─────────────────────────────
//
// LA PESTAÑA VIVE EN LA URL. Guardada sólo en estado de React, recargar
// devolvía siempre a «Nueva campaña» —se perdía dónde estabas— y no había forma
// de pasarle a nadie el enlace del historial.
//
// LA LISTA VIVE ACÁ Y NO EN LA PANTALLA porque la usan la validación de lo que
// viene en la URL y el tipo de las pestañas. Escritas por separado, una pestaña
// nueva entraría en una y no en la otra, y el enlace quedaría roto sin que
// nadie lo note hasta compartirlo.

export const CAMPAIGN_TABS = ['compose', 'drafts', 'scheduled', 'history'] as const;
export type CampaignTab = (typeof CAMPAIGN_TABS)[number];

/** La pestaña de entrada cuando la URL no dice cuál, y la que se muestra si
 *  dice una que no existe. */
export const PESTANA_POR_DEFECTO: CampaignTab = 'compose';

/**
 * Qué pestaña corresponde a un `?tab=` — el de verdad si es válido, y la de
 * entrada si no.
 *
 * ANTE UN VALOR DESCONOCIDO NO SE DEJA LA PANTALLA EN BLANCO. Un enlace viejo,
 * un recorte a medias o una pestaña que se renombró llegan como texto
 * cualquiera; devolver ese texto dejaría la página sin ningún panel que
 * dibujar, y quien abre el enlace no tendría forma de saber qué pasó.
 */
export function pestanaDeLaUrl(valor: string | null | undefined): CampaignTab {
  return (CAMPAIGN_TABS as readonly string[]).includes(valor ?? '')
    ? (valor as CampaignTab)
    : PESTANA_POR_DEFECTO;
}
